const SortingDownIcon = /*#__PURE__*/ [
  ["path", { d: "M6 15.5L18.0001 15.5001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 11.5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 2.5V8.5M8 8.5L6 6.5M8 8.5L10 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 15.5V21.5M12 21.5L10 19.5M12 21.5L14 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M16 2.5V8.5M16 8.5L14 6.5M16 8.5L18 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export { SortingDownIcon as default };
//# sourceMappingURL=SortingDownIcon.js.map
